import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=71b6b428&"
var script = {}
import style0 from "./Divider.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports